var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-348 -16)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 395,
    height: 55,
    x: 0.5,
    y: 0.5,
    fill: "#FFF",
    stroke: "#CECDCC",
    rx: 27.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F59B00",
    d: "M360 34.64c-.16 0-.32-.04-.48-.12l-11.4-11.4c-.08-.08-.12-.22-.12-.42 0-.2.06-.36.18-.48s.26-.16.42-.12c.16.04.32.1.48.18L360 33.2l10.92-10.92c.16-.16.32-.24.48-.24.16 0 .3.06.42.18s.18.28.18.48c0 .2-.04.34-.12.42l-11.4 11.4c-.16.08-.32.12-.48.12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownIcon);
export default __webpack_public_path__ + "static/media/chevron-down_icon.71fc8c024148a07add3c7fc99d120745.svg";
export { ForwardRef as ReactComponent };